import React, { useEffect, useState } from 'react'
import { Container } from 'react-grid-system'
import styles from './ContentModuleSection.module.scss'
import { ContentModuleSectionProps } from '~types'
import { Divider, DynamicComponent } from '~elements'

const ContentModuleSection = ({
  blocks = [],
  showDividerAtBottom,
  showDividerAtTop,
  contentModuleDivId,
  dividerFullWidth
}: ContentModuleSectionProps) => {
  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) return null

  return (
    <>
      <div className={styles['content-module']} id={contentModuleDivId}>
        {showDividerAtTop && <Divider dividerFullWidth={dividerFullWidth} />}
        {blocks && blocks.length > 0 && (
          <Container className='container container--narrow-xxl'>
            {blocks.map(block => (
              <DynamicComponent key={block?.id} block={{ ...block }} />
            ))}
          </Container>
        )}
        {showDividerAtBottom && <Divider dividerFullWidth={dividerFullWidth} />}
      </div>
    </>
  )
}

export default ContentModuleSection
